import React from "react";
import { Menu, Typography, Icon } from "components";
import { useAuth } from "hooks";
import { UserSchool } from "types";
import School from "../school";
import styles from "./SchoolSwitcher.module.css";

const SchoolSwitcher: React.FC = () => {
  const [auth] = useAuth();
  const {
    user,
    subinstallKey,
    school: { teacherDefaultHomeRoute },
  } = auth.data;

  if (!user.userSchools) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Typography variant="label" component="div" className={styles.title}>
        <Icon name="bank-outlined" className={styles.icon} size="medium" />
        School
      </Typography>
      <Menu orientation="vertical">
        {user.userSchools.map((school: UserSchool) => (
          <School
            key={school.subinstall}
            school={school}
            current={subinstallKey === school.subinstall}
            teacherDefaultHomeRoute={teacherDefaultHomeRoute}
          />
        ))}
      </Menu>
    </div>
  );
};

export default SchoolSwitcher;
